import React, { FC } from 'react';
import { IConfig } from '../types/config';
import { IArticle } from '../types/article';

import Layout from './../components/Layout';
import SEO from './../components/Seo';
import Hero from './../sections/Hero';
import ArticlesSponsored from './../sections/ArticlesSponsored';
import ArticlesLatest from './../sections/ArticlesLatest';
import CategoriesHome from './../sections/CategoriesHome';

const Home: FC<{
  pageContext: {
    siteConfig: IConfig;
    articlesSponsored: IArticle[];
    articlesLatest: IArticle[];
    categories: string[];
    language: string;
  };
}> = ({ pageContext: { siteConfig, articlesSponsored, articlesLatest, categories, language } }) => (
  <Layout pageName="home" language={language} config={siteConfig} categories={categories}>
    <Hero config={siteConfig} />
    {articlesSponsored.length ? (
      <ArticlesSponsored language={language} config={siteConfig} articles={articlesSponsored} />
    ) : null}
    {articlesLatest.length ? (
      <ArticlesLatest language={language} config={siteConfig} articles={articlesLatest} />
    ) : null}
    {categories.length ? <CategoriesHome language={language} config={siteConfig} categories={categories} /> : null}
  </Layout>
);

export default Home;

export const Head: FC<{
  pageContext: { siteConfig: IConfig; googleSiteVerification: string; iconUrl: string; language: string };
}> = ({ pageContext: { siteConfig, googleSiteVerification, iconUrl, language } }) => (
  <>
    <html lang={`${language.toLowerCase()}-${language.toUpperCase()}`} />
    {googleSiteVerification ? <meta name="google-site-verification" content={googleSiteVerification} /> : null}
    <SEO
      meta={siteConfig.general.meta.home}
      fonts={siteConfig.general.content.fonts}
      gtmCode={siteConfig.general.gtm}
      iconUrl={iconUrl}
    />
  </>
);
